export default __webpack_public_path__ + "8f25aeb56548a7cd454760a78aaac2da.svg";